window.mDrag = false;

document.addEventListener('mousedown', () => window.mDrag = false);
document.addEventListener('mousemove', () => window.mDrag = true);

$(document).ready(() => {

  $('.js-gallery-video').on('click', (e) => {

    if(!window.mDrag) {

      let link = $(e.currentTarget).attr('data-source');

      $('.js-gallery-video-iframe').attr('src', link);

      $('#galleryModal').modal('show');

    }

  });

})

$('#galleryModal').on('hidden.bs.modal', () => {

  $('.js-gallery-video-iframe').attr('src', '');

});